import type { WidgetBlock } from '@/stores/chatStore';
import ContactCard from './ContactCard';
import DirectionsCard from './DirectionsCard';
import LandmarkCard from './LandmarkCard';
import WeatherCard from './WeatherCard';
import CalendarCard from './CalendarCard';
import MapsCard from './MapsCard';
import NowPlayingCard from './NowPlayingCard';

interface InlineWidgetProps {
  widget: WidgetBlock;
}

export default function InlineWidget({ widget }: InlineWidgetProps) {
  switch (widget.type) {
    case 'contact_card':
      return <ContactCard data={widget.data as any} />;
    case 'directions_card':
      return <DirectionsCard data={widget.data as any} />;
    case 'landmark_card':
      return <LandmarkCard data={widget.data as any} />;
    case 'weather_card':
      return <WeatherCard data={widget.data as any} />;
    case 'calendar_card':
      return <CalendarCard data={widget.data as any} />;
    case 'map_preview':
    case 'maps_card':
      return <MapsCard data={widget.data as any} />;
    case 'now_playing_card':
      return <NowPlayingCard data={widget.data as any} />;
    default:
      return null;
  }
}
